namespace $ {

	export function $bog_max_seed( uk: $bog_max_uk ) {

		uk.Title( 'auto' )!.val( 'УК «Демо-Дом», тестовые данные' )

		const houses = [
			[ 'ул. Пушкина, д. 10', 'pushkina10' ],
			[ 'пр. Победы, д. 5, к. 2', 'pobedy5k2' ],
		] as const

		for( const [ address, code ] of houses ) {
			const house = uk.Houses( 'auto' )!.make( null )
			house.Address( 'auto' )!.val( address )
			house.Code( 'auto' )!.val( code )
		}

		const categories = [
			[ 'Течь, авария на стояке или трубах', 'ads', 'house', 0.5, 72, 'ПП РФ № 416, п. 13: локализация не позднее 30 минут, устранение не позднее 3 суток с момента регистрации заявки' ],
			[ 'Засор канализации', 'ads', 'house', 0.5, 2, 'ПП РФ № 416, п. 13: устранение засора внутридомовой канализации в течение 2 часов с момента регистрации заявки' ],
			[ 'Нет холодной или горячей воды', 'rso', 'house', 0.5, 4, 'ПП РФ № 354, прил. 1: перерыв подачи воды не более 4 часов единовременно и 8 часов суммарно в месяц' ],
			[ 'Не греет отопление', 'uk', 'house', 0.5, 16, 'ПП РФ № 354, прил. 1: перерыв отопления не более 16 часов единовременно при температуре в жилых помещениях выше 12 °C' ],
			[ 'Не работает лифт', 'uk', 'house', null, 24, 'ПП РФ № 170, прил. 2: неисправность лифта устраняется в срок не более 1 суток' ],
			[ 'Не горит свет в подъезде', 'uk', 'house', null, 168, 'ПП РФ № 170, прил. 2: неисправность освещения помещений общего пользования устраняется в течение 7 суток' ],
			[ 'Протечка кровли', 'uk', 'house', null, 24, 'ПП РФ № 170, прил. 2: протечки в отдельных местах кровли устраняются в течение 1 суток' ],
			[ 'Справка, выписка или сверка начислений', 'uk', 'house', null, 72, 'ПП РФ № 416, п. 34: ответ на запрос собственника в срок не более 3 рабочих дней' ],
			[ 'Шум от соседей', 'police', 'house', null, 24, 'Региональный закон о тишине: обращение рассматривает участковый, реакция в течение суток' ],
			[ 'Мусор не вывозят, площадка переполнена', 'municipal', 'yard', null, 24, 'СанПиН 2.1.3684-21, п. 11: вывоз ТКО при температуре выше +5 °C ежедневно' ],
			[ 'Яма на дороге или во дворе', 'municipal', 'city', null, 240, 'ГОСТ Р 50597-2017, табл. 5.3: устранение дефектов покрытия в срок до 10 суток в зависимости от категории дороги' ],
			[ 'Не горит уличный фонарь', 'municipal', 'city', null, 168, 'ГОСТ Р 50597-2017, п. 6.9: восстановление наружного освещения в срок до 7 суток' ],
			[ 'Нужен пешеходный переход, лежачий полицейский, знак', 'municipal', 'city', null, 720, '59-ФЗ, ст. 12: обращение рассматривается в течение 30 дней' ],
			[ 'Предложение по благоустройству', 'municipal', 'city', null, 720, '59-ФЗ, ст. 12: обращение рассматривается в течение 30 дней' ],
		] as const

		for( const [ title, owner, scope, react, fix, basis ] of categories ) {
			const category = uk.Categories( 'auto' )!.make( null )
			category.Title( 'auto' )!.val( title )
			category.Owner( 'auto' )!.val( owner )
			category.Scope( 'auto' )!.val( scope )
			if( react !== null ) category.React( 'auto' )!.val( react )
			category.Fix( 'auto' )!.val( fix )
			category.Basis( 'auto' )!.val( basis )
		}

		const post = uk.Posts( 'auto' )!.make( null )
		post.Title( 'auto' )!.val( 'Плановое отключение горячей воды' )
		post.Text( 'auto' )!.val( 'Гидравлические испытания тепловых сетей. Горячей воды не будет с 9:00 22 сентября до 18:00 23 сентября. Тестовая запись.' )
		post.Kind( 'auto' )!.val( 'outage' )
		post.House( 'auto' )!.remote( uk.Houses( 'auto' )!.remote_list()[0] )
		post.Created( 'auto' )!.val( new $mol_time_moment( '2026-09-16T10:00:00' ) )
		post.Since( 'auto' )!.val( new $mol_time_moment( '2026-09-22T09:00:00' ) )
		post.Till( 'auto' )!.val( new $mol_time_moment( '2026-09-23T18:00:00' ) )

	}

}
